import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import NProgress from 'nprogress';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

const SMShistory = () => {
  const [smsHistory, setSmsHistory] = useState([]);
  const [payHistory, setPayHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

  useEffect(() => {
    const fetchSmsHistory = async () => {
      if (!user) return;

      setLoading(true);
      NProgress.start();
      try {
        const { data } = await axios.get(`${API_URL}/sms/history`);

        // smsList-dan almagy we array boljakdygyny barlamak
        if (Array.isArray(data.smsList)) {
          setSmsHistory(data.smsList);
        } else {
          setSmsHistory([]);
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || 'SMS taryhyny getirip bolmady');
      } finally {
        setLoading(false);
        NProgress.done();
      }
    };

    fetchSmsHistory();
  }, [user]);

  useEffect(() => {
    const fetchPayments = async () => {
      if (!user) return;

      setLoading(true);
      NProgress.start();
      try {
        const { data } = await axios.get(`${API_URL}/sms/payments`);

        // smsList-dan almagy we array boljakdygyny barlamak
        if (Array.isArray(data.payList)) {
          setPayHistory(data.payList);
        } else {
          setPayHistory([]);
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || 'Toleg taryhyny getirip bolmady');
      } finally {
        setLoading(false);
        NProgress.done();
      }
    };

    fetchPayments();
  }, [user]);

  return (
    <>
      <Helmet>
        <title>SMS Serwis - Taryh</title>
      </Helmet>

      <div className="bg-white rounded-lg shadow p-6" >
        <h2 className="text-lg font-medium text-gray-900 mb-4">SMSler</h2>

        {
          loading ? (
            <p className="text-center py-6">SMS taryhy ýüklenýär...</p>
          ) : smsHistory.length === 0 ? (
            <p className="text-center py-6 text-gray-500">Häzirlikçe SMS habarlar ýok!</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {['#', 'Telefon Belgisi', 'Habar', 'Ugratma wagty', 'Ýagdaýy']
                      .map((h, i) => (
                        <th key={i} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                          {h}
                        </th>
                      ))
                    }
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {smsHistory.map((sms, idx) => (
                    <tr key={sms.id}>
                      <td className="px-6 py-4 text-sm text-gray-500">{idx + 1}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">+993-{sms.phoneNumber}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate">
                        {sms.message.length > 50 ? `${sms.message.substring(0, 50)}...` : sms.message}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {sms.sentAt ? new Date(sms.sentAt).toLocaleString() : 'ugradylmadyk'}
                      </td>
                      <td className={`px-6 py-4 text-sm 
                                ${sms.status === 'nosend' ? 'text-red-600' :
                          sms.status === 'sent' ? 'text-green-600' :
                            sms.status === 'failed' ? 'text-red-600' :
                              sms.status === 'nobalance' ? 'text-red-400' : ''
                        }`}>
                        {sms.status === 'nosend' ? 'Garaşylýar' :
                          sms.status === 'sent' ? 'OK' :
                            sms.status === 'failed' ? 'Näsazlyk' :
                              sms.status === 'nobalance' ? 'Balans ýetmezçiligi' : ''}
                      </td>


                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }

      </div><br />
      <div className="bg-white rounded-lg shadow p-3" >
        <h2 className="text-lg font-medium text-gray-900 mb-4">Tölegler</h2>

        {
          loading ? (
            <p className="text-center py-6">Töleg hereketleri ýüklenilýär...</p>
          ) : payHistory.length === 0 ? (
            <p className="text-center py-6 text-gray-500">Hiç hili töleg hereketleri ýok!</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {['#', 'Mukdary', 'Tipi', 'Düşündiriş', 'Senesi']
                      .map((h, i) => (
                        <th key={i} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                          {h}
                        </th>
                      ))
                    }
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {payHistory.map((pay, idx) => (
                    <tr key={pay.id}>
                      <td className="px-6 py-4 text-sm text-gray-500">{idx + 1}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{pay.amount}</td>
                      <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                        {pay.type}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {pay.description}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {new Date(pay.createdAt).toLocaleString()}
                      </td>


                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </div >
    </>
  );
};

export default SMShistory;
